/*
 * Module for the Insurance edit view
*/
rs.module("content/system/configuration/availablepaycomponent/ratehistorytab",

    [ "controls/components/event-banner" ],

    function (eventBanner) {
        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, columnIds, grid, ajaxUrl) {

            var rateHistoryForm = $.js(jsSelectors.rateHistoryForm, { required: false });
            var addButton = $.js(jsSelectors.addButton, { required: false });
            var ratePercent = rateHistoryForm.js(jsSelectors.ratePercent, { required: false });
            var rateAmount = rateHistoryForm.js(jsSelectors.rateAmount, { required: false });
            var effectiveDate = rateHistoryForm.js(jsSelectors.effectiveDate, { required: false });
            var terminationDate = rateHistoryForm.js(jsSelectors.terminationDate, { required: false });
            var updateToken = rateHistoryForm.js(jsSelectors.updateToken, { required: false });
            var rateHistoryKey = rateHistoryForm.js(jsSelectors.rateHistoryKey, { required: false });
            var payComponentType = rateHistoryForm.js(jsSelectors.payComponentType, { required: false });

            // update the editable controls when selecting from the grid
            if (grid) {
                grid.selectionChanged(function (values, rows) {
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();
                        $.get(
                            ajaxUrl,
                            {
                                rateHistoryKey: rows[0][columnIds.rateHistoryKey],
                                payComponentType: payComponentType.val()
                            },

                            function (data) {
                                ratePercent.val(data.ratePercent);
                                rateAmount.val(data.rateAmount);
                                effectiveDate.val(data.effectiveDate ? new Date(data.effectiveDate).toISODateString() : null).clearErrors();
                                terminationDate.val(data.terminationDate ? new Date(data.terminationDate).toISODateString() : null).clearErrors();
                                updateToken.val(data.updateToken);
                                rateHistoryKey.val(rows[0][columnIds.rateHistoryKey]);

                                rateAmount.prop('disabled', ratePercentHasValue());
                                ratePercent.prop('disabled', rateAmountHasValue());
                            }
                        );
                    }
                });
            }

            if (!rateHistoryKey.val()) {
                rateHistoryKey.val(-1);
            }

            ratePercent.change(ratePercentChange);

            //enable/disable amount on percent change
            function ratePercentChange() {
                rateAmount.prop('disabled', ratePercentHasValue());
                if (ratePercent.val() != 0) {
                    rateAmount.val(null);
                }
            }

            // return true if rate percent has a nonzero value
            function ratePercentHasValue() {
                return ratePercent.val() != 0 && ratePercent.val() != "0%";
            }

            rateAmount.change(rateAmountChange);

            // enable/disable percent on amount change
            function rateAmountChange() {
                ratePercent.prop('disabled', rateAmountHasValue());
                if (rateAmount.val() != 0) {
                    ratePercent.val(null);
                }
            }

            // return true if rate amount has a nonzero value
            function rateAmountHasValue() {
                return rateAmount.val() != 0 && rateAmount.val() != "$0.00";
            }

            // clear and enable editable controls
            addButton.click(function () {
                eventBanner.removeAllMessages();

                rateAmount.prop('disabled', false);
                ratePercent.prop('disabled', false);

                rateAmount.val(null);
                ratePercent.val(null);
                effectiveDate.val(null);
                terminationDate.val(null);
                rateHistoryKey.val(-1);

                grid.selectedValues = null;
            });

            _executeSelectionChanged = true;
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);